/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatorOnPremApiKeyDeleteSpec { 
    /**
     * The organization ID for the VLCR provider.
     */
    vlcr_org_id: string;
    /**
     * Provide approval to delete a CB on-premises deployment in PENDING_DELETION_APPROVAL state.
     */
    approve_deletion?: boolean;
    /**
     * Ignore Failures During API Key Deactivation/Deletion from EDR vendor.
     */
    ignore_api_key_deactivation_failure?: boolean;
    /**
     * Ignore Failures During EDR org deprovision from EDR vendor.
     */
    ignore_edr_org_deprovision_failure?: boolean;
}

